// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from './TEMPLATE'

export const Ticket_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M21.75 9.75A.75.75 0 0 0 22.5 9V6A1.5 1.5 0 0 0 21 4.5H3A1.5 1.5 0 0 0 1.5 6v3a.75.75 0 0 0 .75.75 2.25 2.25 0 0 1 0 4.5.75.75 0 0 0-.75.75v3A1.5 1.5 0 0 0 3 19.5h18a1.5 1.5 0 0 0 1.5-1.5v-3a.75.75 0 0 0-.75-.75 2.25 2.25 0 0 1 0-4.5ZM3 15.675a3.75 3.75 0 0 0 0-7.35V6h5.25v12H3Zm18 0V18H9.75V6H21v2.325a3.75 3.75 0 0 0 0 7.35Z',
  viewBox: '0 0 24 24',
  glyph: 'Ticket_Stroke2_Corner0_Rounded',
})
